export * from './hotel-content-api';
